// A write in one tab leaves this browser's other Bosko tabs holding prefetched
// pages and history from before it (#614). Each tab keeps its mutation epoch to
// itself, so the epoch crosses over here, as a bare number. Best effort: a tab
// that misses one is only as stale as it would be without this. No shared
// storage either, which would need a privacy disclosure.

const CHANNEL = 'bosko:mutations';

let channel = null;

function openChannel() {
  try {
    return typeof window.BroadcastChannel === 'function'
      ? new window.BroadcastChannel(CHANNEL)
      : null;
  } catch {
    return null; // Refused in some sandboxed and embedded contexts.
  }
}

export function publishMutation(at) {
  try {
    channel?.postMessage(at);
  } catch {
    // Other tabs stay as they were; this one already has its epoch.
  }
}

// Returns what closes the channel again.
export function listenForMutations(onMutation) {
  const opened = openChannel();
  if (!opened) return () => {};
  opened.onmessage = ({ data }) => {
    if (Number.isFinite(data)) onMutation(data);
  };
  channel = opened;
  return () => {
    if (channel === opened) channel = null;
    opened.close();
  };
}
